export const DIGIT_CHAR_CODE_START = 48;
export const CHAR_CODE_LIMIT_2 = 57;
export const wrapperClassname = 'flex flex-col gap-16';
